export enum BILLPAYMENTHTTPSTATUSCODES {
    SUCCESS = 1,
    WRONG_PIN_ATTEMPTS = 118,
    WRONG_PIN_ATTEMPTS_SN = 5800,
    PREPAID_PRODUCT_BILL_PAYMENT_VALIDATION_FAIL = 8111,
    BILL_PAYMENT_PURCHASE_INITIALIZATION_FAIL = 8112,
}
export enum WALLET_SERVICE_CATEGORIES {
   BILL_PAY = 2
}


// WEBPACK FOOTER //
// ./src/model/types/wallet-services-type.ts